import { useQueryClient } from 'react-query';

export default function useProfile() {
  const queryClient = useQueryClient();
  const profile: any = queryClient.getQueryData('profile');
  return profile?.data;
}
